import { i18n } from "i18next";
import * as Constants from "../constants";

export interface MarkdownStrContent {
  content: string;
  locale: string;
}

export async function getLocalisedContent(
  pageName: string,
  i18n: i18n
): Promise<MarkdownStrContent> {
  let resolvedLang = i18n.resolvedLanguage;
  let contentUrl =
    Constants.LOCAL_RESSOURCES_URL + `${resolvedLang}/${pageName}.md`;
  let response = await fetch(contentUrl);
  return {
    content: await response.text(),
    locale: resolvedLang,
  };
}
